/* sb-dc-copytrim.js — cut the chatter in the design center. 2026-09-04.

   The editor explains itself twice over: a sentence under every heading, a
   paragraph above the finishing list, and a description under each finishing
   option that starts by repeating the option's own name. Customers said the
   screen is hard to use, and the first thing to try is fewer words.

   Rules of the edit:
     - anything that repeats what the label already says: gone
     - anything that tells the customer how the interface works: gone
     - anything that changes what they get or what they pay: kept, shortened

   So the hem spacing, the roll width limit, the free-finishing fact, the file
   types and the proof warnings all stay — those turn into reprints if the
   customer misses them. The tour-guide sentences do not.

   Matching is on the exact rendered text, which is brittle by nature: change a
   sentence in sb-dc-aug.js and its rule here simply stops matching, leaving
   the original copy on screen. That is the safe direction to fail in. Every
   rule that did not match is listed in window.__dcCopyTrim.missed, so a
   wording change shows up as a stale rule rather than a silent loss.

   Nothing is deleted from the DOM: hidden lines keep their element, and
   shortened ones keep the original in a data attribute. */
(function () {
  'use strict';

  /* text -> null to hide, or a shorter replacement */
  var RULES = [
    /* --- the modal ------------------------------------------------------ */
    ['Pick the product, size and finishing first and the canvas will be set up for you.', null],
    ['Pick a category to see its products.', null],
    ['Quantity discounts start at 2 pcs (2\u20134 pcs 2%, 5\u20139 pcs 5%, 10+ pcs 10% and up).',
     'Discounts from 2 pcs.'],
    ['All finishing is free. The hem folds, the grommets punch through, and the pole pocket swallows that much inward.',
     'All finishing is free.'],
    ['Both materials cost the same. You can also change it later in the \u300cMaterial\u300d panel on the left.',
     'Same price either way \u2014 changeable later.'],
    ['Choose in 1-foot steps. The roll is 8ft wide, so one of width or height must be 8ft or less.',
     'Whole feet \u00b7 one side 8ft or less.'],

    /* --- the left panels ------------------------------------------------ */
    ['Choose in 1-foot steps. One of width or height must be 8ft or less.',
     'Whole feet \u00b7 one side 8ft or less.'],
    ['Viewing distance sets the minimum text size. The resolution requirement is the company standard (at ',
     'Sets the minimum text size at '],

    /* --- the canvas ------------------------------------------------------ */
    ['Drop a logo or photo anywhere on the screen to upload it', null],
    ['Drop it and it lands on the canvas', null]
    /* 'PNG · JPG · GIF · WEBP · SVG · up to 20MB' stays: it is the one line
       that stops a customer trying to upload a PDF. */
  ];

  /* A finishing description opens by repeating the option's own name, e.g.
     "Hem & Grommets · Standard · hem folded on all sides + grommets…". Drop the
     repeat, keep the spec. */
  var FINISH_PREFIXES = [
    'Hem & Grommets \u00b7 ', 'Hem Only \u00b7 ', 'No Hem / Grommets Only \u00b7 ',
    'No Hem & No Grommets \u00b7 ', 'Pole Pockets (Top and Bottom) \u00b7 ',
    'Pole Pockets (Top Only) \u00b7 '
  ];

  var state = { hidden: 0, shortened: 0, missed: [] };
  window.__dcCopyTrim = state;

  function css() {
    if (document.getElementById('sbdc-copytrim-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-copytrim-css';
    st.textContent =
      '[data-sbdc-trim="hide"]{display:none !important}' +
      /* Two lines is plenty for a spec; the rest was always overflow anyway. */
      '[data-sbdc-trim="clamp"]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}';
    document.head.appendChild(st);
  }

  function leaves() {
    return document.querySelectorAll('p, span, div, small, li');
  }

  function sweep() {
    var seen = {};
    var nodes = leaves();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.sbdcTrim) continue;
      if (el.children.length) continue;                 // text-only nodes
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 200) continue;

      var done = false;
      for (var r = 0; r < RULES.length; r++) {
        var from = RULES[r][0].replace(/\s+/g, ' ').trim(), to = RULES[r][1];
        if (t !== from && t.indexOf(from) !== 0) continue;
        seen[r] = 1;
        if (to === null) { el.dataset.sbdcTrim = 'hide'; state.hidden++; }
        else {
          el.dataset.sbdcOriginal = t;
          el.dataset.sbdcTrim = 'short';
          /* A prefix rule keeps whatever followed it (the DPI badge lives in a
             sibling, so only this node's text changes). */
          el.textContent = (t === from) ? to : to + t.slice(from.length);
          state.shortened++;
        }
        done = true;
        break;
      }
      if (done) continue;

      for (var p = 0; p < FINISH_PREFIXES.length; p++) {
        var pre = FINISH_PREFIXES[p].replace(/\s+/g, ' ');
        if (t.indexOf(pre) === 0) {
          el.dataset.sbdcOriginal = t;
          el.dataset.sbdcTrim = 'clamp';
          el.textContent = t.slice(pre.length);
          state.shortened++;
          break;
        }
      }
    }

    /* Report rules that never matched — they are the ones to revisit when the
       app's wording changes under us. */
    state.missed = RULES.map(function (r, i) { return seen[i] ? null : r[0].slice(0, 40); })
                        .filter(Boolean);
  }

  function start() {
    css();
    sweep();
    /* React repaints these panels constantly and the modal is rebuilt on every
       open, so re-run rather than hook anything. */
    var t = setInterval(sweep, 400);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
